const STORAGE_KEY = 'bhyve-notifications-sound-enabled'

export const NOTIFICATION_SOUND_CHANGE_EVENT = 'bhyve-notification-sound-preference'

/** Default off — users can enable from the notifications panel. */
export function getNotificationSoundEnabled(): boolean {
  if (typeof window === 'undefined') return false
  try {
    const v = window.localStorage.getItem(STORAGE_KEY)
    if (v === null) return false

    return v === '1' || v === 'true'
  } catch {
    return false
  }
}

export function setNotificationSoundEnabled(enabled: boolean): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0')
    window.dispatchEvent(
      new CustomEvent(NOTIFICATION_SOUND_CHANGE_EVENT, {
        detail: { enabled }
      })
    )
  } catch {
    // private mode / quota
  }
}
